const gettEnv = {
    ...window.gettEnv,
    ...process.env,
};

export default gettEnv;
